import { useCallback } from 'react';

export type ExclusionType = 'sessions' | 'classes' | 'events' | 'parents';

export interface Item {
  label: string;
  value: string;
}

// Sample data for multi-select options
const sessions: Array<Item> = Array.from({ length: 50 }, (_, i) => ({
  label: `Session ${i + 1} - ${['Spring', 'Summer', 'Fall', 'Winter'][i % 4]} ${2025 + Math.floor(i / 12)}`,
  value: `session-${i + 1}`,
}));

const classes: Array<Item> = Array.from({ length: 75 }, (_, i) => ({
  label: `Class ${i + 1} - ${['Programming', 'Mathematics', 'Science', 'Arts', 'Business'][i % 5]} Level ${Math.floor(i / 15) + 1}`,
  value: `class-${i + 1}`,
}));

const events: Array<Item> = Array.from({ length: 40 }, (_, i) => ({
  label: `Event ${i + 1} - ${['Workshop', 'Conference', 'Seminar', 'Fair'][i % 4]}`,
  value: `event-${i + 1}`,
}));

const parents: Array<Item> = Array.from({ length: 100 }, (_, i) => ({
  label: `Parent ${i + 1} - ${['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez'][i % 10]}, ${['John', 'Mary', 'James', 'Patricia', 'Robert', 'Jennifer', 'Michael', 'Linda', 'William', 'Elizabeth'][i % 10]}`,
  value: `parent-${i + 1}`,
}));

export function useLateFeesData() {
  const getItemsByType = useCallback((type: ExclusionType): Array<Item> => {
    switch (type) {
      case 'sessions':
        return sessions;
      case 'classes':
        return classes;
      case 'events':
        return events;
      case 'parents':
        return parents;
      default:
        return [];
    }
  }, []);

  const getTitleByType = useCallback((type: ExclusionType): string => {
    switch (type) {
      case 'sessions':
        return 'Sessions';
      case 'classes':
        return 'Classes';
      case 'events':
        return 'Events';
      case 'parents':
        return 'Parents';
      default:
        return '';
    }
  }, []);

  return {
    getItemsByType,
    getTitleByType,
  };
}
